<template>
    <div class="single-product__information">
        <div class="single-product__information-section">
            <div class="single-product__information__slider splide" id="splide01" role="region" aria-roledescription="carousel">
                <div class="splide__track" id="splide01-track" style="padding-left: 0px; padding-right: 0px;" aria-live="polite" aria-atomic="true" aria-busy="false">
                    <ul class="splide__list" id="splide01-list" role="presentation">
                        <li v-for="(item, index) in information" :key="index" class="splide__slide" role="tabpanel" aria-roledescription="slide" style="width: calc(100%); transform: translateX(0%); transition: opacity 1500ms cubic-bezier(0.25, 1, 0.5, 1);">
                            <div class="pt_row_custom">
                                <div v-if="item.media_type == 'image'" class="wid50  px-0">
                                    <img class="img-fluid d-none d-md-inline mb-md-0px alt-lazy-img" :src="item.image_lazy || item.image"  :data-original_src="item.image" :alt="item.alt ?? ''">
                                    <img class="img-fluid d-inline d-md-none mb-md-0px alt-lazy-img" :src="item.mobile_image_lazy || item.mobile_image || item.image" :data-original_src="item.mobile_image || item.image" :alt="item.alt ?? ''" />
                                </div>
                                <div v-else-if="item.media_type == 'video'" class="wid50  px-0">
                                    <video class="master_video d-desktop" id="master_video2" muted playsinline loop repeat autoplay :controls="item.show_video_controls">
                                        <source :src="`${item.video}`" type="video/mp4">
                                    </video>
                                    <video class="master_video d-mobile" id="master_video2" muted playsinline loop repeat autoplay :controls="item.show_video_controls">
                                        <source :src="item.video_mobile !== '' ? item.video_mobile : item.video" type="video/mp4">
                                    </video>
                                </div>
                                <div v-else-if="item.media_type == 'embed'" class="wid50  px-0" >
                                    <div class="video_ytb" v-html="item.embed_video_code"></div>
                                </div>
                                <div class="wid50 right_content_sl">
                                    <h2 class="agp-normal mb-10px">
                                        {{ item.title }}
                                    </h2>
                                    <div class="ct_slider">
                                        <div v-html="item.slider_description"></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_information.scss";
</style>

<script setup lang="ts">
    import Splide from "@splidejs/splide"
    import { onMounted } from "vue"

    const props = defineProps(["data"]);
    const information = computed(() => props.data);

    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    onMounted(() => {
        altLazyIO();
        var master_slider = new Splide('.single-product__information__slider', {
            type: 'fade',
            perPage: 1,
            rewind: false,
            pagination: true,
            arrows: true,
            speed: 1500,
            autoplay: true,
            interval: 10000,
            classes: {
                arrows: 'splide__arrows',
                arrow: 'splide__arrow',
                prev: 'splide__prev',
                next: 'splide__next',
            },
        });

        master_slider.on('mounted resize', function () {
            const numberSlider = document.querySelectorAll<HTMLElement>(".single-product__information .single-product__information__slider .splide__list .splide__slide");

            if (numberSlider.length === 1) {
                const paginationElement = document.querySelector<HTMLElement>(".single-product__information .single-product__information__slider .splide__pagination");
                const arrowsElement = document.querySelector<HTMLElement>(".single-product__information .single-product__information__slider .splide__arrows");

                if (paginationElement) {
                    paginationElement.style.display = 'none';
                }

                if (arrowsElement) {
                    arrowsElement.style.display = 'none';
                }
            }
        });

        master_slider.mount();
    })
</script>